import React from "react";
import { FormattedMessage, } from 'react-intl';
import AvailabilityContainer from "../Availability/AvailabilityContainer";
import ScheduleCalendarContainer from "../ScheduleCalendar/ScheduleCalendarContainer";
import ShiftTemplatesList from '../ScheduleCalendar/ShiftTemplates/ShiftTemplatesList';
import DemandPlannerContainer from "../DemandPlanner/DemandPlannerContainer";

import './ScheduleTabComponent.scss';
import 'stylesheets/tab.scss';

import moment from 'moment-timezone';
import 'stylesheets/layout.scss';
import 'stylesheets/fonts.scss';
import { Mixpanel } from 'helpers/Mixpanel';
import AppDownloadModal from "pages/CommunityMergeFeed/CreateFeed/AppDownloadModal";
import AssistantPanel from "pages/AgenticAi/AssistantPanel";
import AssistantButton from "pages/AgenticAi/AssistantButton";
class ScheduleTabComponent extends React.Component {
    state = {
        activeTab: 1,
        showAppDownloadModal: false,
        showAssistant: false,
        assistantMinimized: false,
        assistantMessages: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { match } = this.props;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const dismissed = localStorage.getItem('appDownloadModalDismissedd');

        const initialTab = match.params.module;
        if (initialTab === 'availability') {
            this.setState({ activeTab: 2 });
            Mixpanel.track('Availability Page')
        } else {
            this.setState({ activeTab: 1 });
            Mixpanel.track('Schedule Page')
        }

        if (isMobile && !dismissed) {
            this.setState({ showAppDownloadModal: true });
        }
    }

    componentDidUpdate() {

    }

    handleScheduleClick = () => {
        this.setState({ activeTab: 1 });
        Mixpanel.track('Schedule Page')
    }

    handleAvailabilityClick = () => {
        this.setState({ activeTab: 2 });
        Mixpanel.track('Availability Page')
    }

    handleTemplatesClick = () => {
        this.setState({ activeTab: 4 });
        Mixpanel.track('Templates Page')
    }

    handleAssistantOpen = () => {
        this.setState({ showAssistant: true, assistantMinimized: false });
    };

    handleAssistantMinimize = () => {
        this.setState({ assistantMinimized: true, showAssistant: false });
    };

    handleAssistantClose = () => {
        this.setState({ showAssistant: false, assistantMinimized: false, assistantMessages: [] });
    };

    setAssistantMessages = (updater) => {
        this.setState(prevState => ({
            assistantMessages: typeof updater === 'function' ? updater(prevState.assistantMessages) : updater
        }));
    };

    handleDemandPlannerClick = () => {
        this.setState({ activeTab: 3 });
        Mixpanel.track('Demand Planner Page')
    }

    render() {
        const { locationSettings, allUsers, locationData, addDraftShiftToUserDispatch, deleteShiftsDispatch, editSingleShiftDispatch } = this.props;
        const { activeTab, showAppDownloadModal } = this.state;
        let env_check = (process.env.NODE_ENV === 'production' && window.location.hostname.includes("web.myshyft.com"));
        var zone_name = moment.tz.guess();
        var timezone = moment.tz(zone_name).zoneAbbr();

        const timeZoneText = (<FormattedMessage id="ScheduleCalendarComponent.tz" defaultMessage="Your Time Zone: " />);
        const scheduleListItem = (<FormattedMessage id="ShiftHeaderComponent.schedule" defaultMessage="Schedule" />);
        const availabilityListItem = <FormattedMessage id="Availability.availability" defaultMessage="Availability" />;
        const demandPlannerListItem = (
            <span>
                <FormattedMessage id="DemandPlanner.demandPlanner" defaultMessage="Demand Planner" />
                <span className="beta-tag">BETA</span>
            </span>
        );

        const shouldShowAvailability = (locationSettings.cfg__availability === 1);

        return (
            <div className="top-tab_wrap">

                <div className="flex-row schedule-calendar_header">
                    <div className="top-tab_list">
                        <ul>
                            <li className={(activeTab === 1 ? 'active-li' : '')} onClick={this.handleScheduleClick}>{scheduleListItem}</li>
                            {shouldShowAvailability && <li className={(activeTab === 2 ? 'active-li' : '')} onClick={this.handleAvailabilityClick}>{availabilityListItem}</li>}
                            {/* TODO: re-enable when ready for release */}
                            {false && <li className={(activeTab === 3 ? 'active-li' : '')} onClick={this.handleDemandPlannerClick}>{demandPlannerListItem}</li>}
                            {/* {!env_check && <li className={(activeTab === 4 ? 'active-li' : '')} onClick={this.handleTemplatesClick}>Templates</li>} */}
                        </ul>
                    </div>
                    <div className="schedule-calendar_tz fs12px averta-regular"> {timeZoneText} {timezone}</div>
                </div>

                <div className="top-tab_container" style={{ flexGrow: 1, overflowY: 'auto', height: 'auto', minHeight: 'calc(100vh - 200px)' }}>
                    {activeTab === 1 && <ScheduleCalendarContainer locationSettings={locationSettings} />}
                    {activeTab === 2 && <AvailabilityContainer />}
                    {/* TODO: re-enable when ready for release */}
                    {false && activeTab === 3 && <DemandPlannerContainer />}
                    {/* {activeTab === 4 && <ShiftTemplatesList />} */}
                </div>

                {showAppDownloadModal && (
                    <AppDownloadModal
                        showModal={showAppDownloadModal}
                        setShowModal={(val) => {
                            if (!val) {
                                localStorage.setItem('appDownloadModalDismissedd', 'true');
                            }
                            this.setState({ showAppDownloadModal: val });
                        }}
                    />

                )}
                {/* {this.state.showAssistant && (
                    <AssistantPanel
                        allUsers={allUsers}
                        locationData={locationData}
                        addDraftShiftToUserDispatch={addDraftShiftToUserDispatch}
                        deleteShiftsDispatch={deleteShiftsDispatch}
                        editSingleShiftDispatch={editSingleShiftDispatch}
                        messages={this.state.assistantMessages}
                        setMessages={this.setAssistantMessages}
                        onClose={this.handleAssistantClose}
                        onMinimize={this.handleAssistantMinimize}
                    />
                )}
                {this.state.assistantMinimized && (
                    <AssistantButton onClick={this.handleAssistantOpen} />
                )}
                {!env_check && !this.state.showAssistant && !this.state.assistantMinimized && (
                    <AssistantButton onClick={this.handleAssistantOpen} />
                )} */}

            </div>
        );
    }

}

export default ScheduleTabComponent;